import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { updateModulePermissionsStatusAsync } from '../workorders/workorderThunk';
export const loadingSlice = createSlice({
    name: 'app/loading',
    initialState: {
        // isLoading: false
        pendingRequest: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(isPending, (state, action) => {
            if (action.type !== updateModulePermissionsStatusAsync.pending.type) {
                state.pendingRequest += 1;
            }
        });
        builder.addMatcher(isFulfilled, (state, action) => {
            if (action.type !== updateModulePermissionsStatusAsync.fulfilled.type) {
                state.pendingRequest -= 1;
            }
        });
        builder.addMatcher(isRejected, (state, action) => {
            if (action.type !== updateModulePermissionsStatusAsync.rejected.type) {
                state.pendingRequest -= 1;
            }
        });
    }
});
export const selectIsLoading = (state) => state.loading.pendingRequest > 0;
export default loadingSlice.reducer;
